import React, { useEffect } from 'react';
import Select from 'react-select';
import 'bootstrap/dist/css/bootstrap.css';

import { useGlobalContext } from '../../context';

const ENTIRE_US_LABEL = 'Entire US';

const selectStyles = {
  control: provided => ({
    ...provided,
    backgroundColor: '#ffffff',
    borderColor: '#ced4da',
    color: '#212529',
    boxShadow: 'none'
  }),
  singleValue: provided => ({
    ...provided,
    color: '#212529'
  }),
  input: provided => ({
    ...provided,
    color: '#212529'
  }),
  placeholder: provided => ({
    ...provided,
    color: '#6c757d'
  }),
  menu: provided => ({
    ...provided,
    backgroundColor: '#ffffff',
    color: '#212529'
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? '#344675' : state.isFocused ? '#e9ecef' : '#ffffff',
    color: state.isSelected ? '#ffffff' : '#212529'
  })
};

const DispatchMarketsSelection = ({ memoizedOptions, regionCounts = {}, activeTabLabel = '' }) => {
  const { setMarketId, setCoordinates, setMarketIdArray, setIsSingleMarket, selectedMarketLabelValue, setSelectedMarketLabelValue, setRegionId } = useGlobalContext();

  const hasUsableSelectedScope = selectedValue => {
    if (!selectedValue || !selectedValue.value) {
      return false;
    }

    const { scopeType, idArray, id } = selectedValue.value;

    if (scopeType === 'country' || scopeType === 'region') {
      return Array.isArray(idArray) && idArray.length > 0;
    }

    return Boolean(id);
  };

  const selectMarket = selectedOption => {
    if (!selectedOption) {
      return;
    }

    setSelectedMarketLabelValue(selectedOption);
    if (selectedOption.value.scopeType === 'country' || selectedOption.value.scopeType === 'region') {
      setMarketIdArray(selectedOption.value.idArray);
      setIsSingleMarket(false);
      if (selectedOption.value.scopeType === 'region') {
        setRegionId(selectedOption.value.id);
      } else {
        setRegionId('');
      }
    } else {
      setMarketId(selectedOption.value.id);
      setMarketIdArray([selectedOption.value.id]);
      setIsSingleMarket(true);
    }
    setCoordinates(selectedOption.value.coordinates);
  };

  const resolveSelectedOption = () => {
    if (!Array.isArray(memoizedOptions) || memoizedOptions.length === 0) {
      return null;
    }

    const currentValue = selectedMarketLabelValue && selectedMarketLabelValue.value ? selectedMarketLabelValue.value : null;
    const currentLabel = selectedMarketLabelValue && selectedMarketLabelValue.label ? selectedMarketLabelValue.label : '';

    if (currentValue && currentValue.scopeType === 'market' && currentValue.id) {
      return memoizedOptions.find(option => option && option.value && option.value.scopeType === 'market' && option.value.id === currentValue.id) || null;
    }

    if (currentValue && currentValue.scopeType === 'region' && currentValue.id) {
      return memoizedOptions.find(option => option && option.value && option.value.scopeType === 'region' && option.value.id === currentValue.id) || null;
    }

    if (currentValue && currentValue.scopeType === 'country') {
      return memoizedOptions.find(option => option && option.value && option.value.scopeType === 'country') || null;
    }

    if (currentLabel === ENTIRE_US_LABEL) {
      return memoizedOptions.find(option => option && option.value && option.value.scopeType === 'country') || null;
    }

    return null;
  };

  useEffect(() => {
    const resolvedSelectedOption = resolveSelectedOption();
    const hasSelectedScope = hasUsableSelectedScope(selectedMarketLabelValue);
    const defaultOption = Array.isArray(memoizedOptions) && memoizedOptions.length > 0
      ? memoizedOptions.find(option => option.value.scopeType === 'country') || memoizedOptions[0]
      : null;
    const nextOption = resolvedSelectedOption || (!hasSelectedScope ? defaultOption : null);

    if (nextOption && nextOption !== selectedMarketLabelValue) {
      selectMarket(nextOption);
    }
  }, [memoizedOptions, selectedMarketLabelValue]);

  const getOptionCount = option => {
    if (!option || !option.value) {
      return null;
    }

    if (option.value.scopeType === 'country') {
      return regionCounts['Entire US'];
    }

    if (option.value.scopeType === 'region') {
      return regionCounts[option.value.regionName];
    }

    return null;
  };

  const formatOptionLabel = option => {
    const count = getOptionCount(option);
    const showCount = typeof count === 'number';

    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '12px',
          paddingLeft: `${(option.value.depth || 0) * 14}px`
        }}
      >
        <span style={{ fontWeight: option.value.scopeType !== 'market' ? 600 : 400 }}>{option.label}</span>
        {showCount ? (
          <span
            style={{
              minWidth: '32px',
              padding: '2px 8px',
              borderRadius: '999px',
              backgroundColor: count > 0 ? '#17a2b8' : 'rgba(255,255,255,0.08)',
              color: '#ffffff',
              textAlign: 'center',
              fontSize: '12px',
              fontWeight: 700
            }}
            title={activeTabLabel ? `${activeTabLabel} orders` : 'Orders'}
          >
            {count}
          </span>
        ) : null}
      </div>
    );
  };

  return (
    <Select
      // className="mt-4 col-md-8 col-offset-4"
      value={selectedMarketLabelValue}
      onChange={selectMarket}
      options={memoizedOptions}
      formatOptionLabel={formatOptionLabel}
      styles={selectStyles}
      // defaultValue={{ label: 'Lake Charles, LA', value: { id: 'b641bc13-8f56-4f4b-b1ea-c1f833b982bd', coordinates: { latitude: 30.23119, longitude: -93.21163 } } }}
    />
  );
};

export default DispatchMarketsSelection;
